import React, {useEffect} from 'react';
import {useStore} from '@/app/providers/StoreProvider';
import {TeamItem} from './TeamItem';
import {Loading} from "@/shared/ui/Loading";
import {observer} from "mobx-react-lite";


export const TeamList = observer(() => {
    const {ratingStore} = useStore();
    const {rating} = ratingStore;
    return (
        <div className='teams-list'>
            {
                rating.map((item) => (
                    <TeamItem team={item.team} key={item.team.id}/>
                ))
            }
        </div>
    );

});
